import {mapState} from "vuex";
import {MOBILE_WINDOW_WIDTH} from "@/params";

export default {
    computed: {
        ...mapState({
            path: state => state.navbar.path,
            menuColor: state => state.navbar.menuColor,
            windowWidth: state => state.navbar.windowWidth,
            showDemo: state => state.navbar.showDemo
        }),
        classesLinkBlock() {
            return (paths, addClasses = []) => {
                let classes = {
                    'active': paths.includes(this.path)
                }
                Object.assign(classes, ...addClasses.map(cls => ({[cls]: true})));

                return classes;
            }
        },
        stylesLinkBlock() {
            return paths => {
                return {
                    'background-color': paths.includes(this.path) ? this.hexToRgba(this.menuColor, 0.1) : '',
                }
            }
        },
        homeUrl() {
            return location.origin;
        },
        mainUrl() {
            return location.origin.replace(/^(https?:\/\/)[^./]+?\./i, '$1');
        },
        isActive() {
            return paths => paths.includes(this.path);
        },
        isMobile: vm => vm.windowWidth === 0 ? undefined : vm.windowWidth < MOBILE_WINDOW_WIDTH,
        helpPath: vm => vm.projectId ? `project/${vm.projectId}/help` : 'help'
    },
    methods: {
        hexToRgba(hex, alpha) {
            let r = parseInt(hex.substring(1, 3), 16);
            let g = parseInt(hex.substring(3, 5), 16);
            let b = parseInt(hex.substring(5, 7), 16);

            r /= 255;
            g /= 255;
            b /= 255;

            return `rgba(${r * 100}%, ${g * 100}%, ${b * 100}%, ${alpha})`;
        },
    }
}
